import { NgModule } from '@angular/core';

import { LocaisComponent } from './locais.component';
import { SharedModule } from "../../shared/shared.module";
import { LocaisRoutingModule } from "./locais-routing.module";
import { LocalApiService } from "./shared/local-api.service";
import { LocalNavigationService } from "./shared/local-navigation.service";
import { LocalService } from "./shared/local.service";
import { LocalFormComponent } from './local-form/local-form.component';
import { LocalListComponent } from './local-list/local-list.component';
import { BombasModule } from "../bombas/bombas.module";
import { LocalCombustivelFormComponent } from "./local-combustivel-form/local-combustivel-form.component";
import { LocalCombustivelListComponent } from "./local-combustivel-list/local-combustivel-list.component";

@NgModule({
    imports: [
        SharedModule,
        BombasModule,
        LocaisRoutingModule
    ],
    providers: [
        LocalApiService,
        LocalNavigationService,
        LocalService
    ],
    declarations: [
        LocaisComponent,
        LocalFormComponent,
        LocalListComponent,
        LocalCombustivelFormComponent,
        LocalCombustivelListComponent
    ],
    exports: [
        LocalCombustivelFormComponent,
        LocalCombustivelListComponent
    ]
})
export class LocaisModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/locais/locais.module.ts
 **/